import { MancalaMoveGenerator } from '../common/MancalaMoveGenerator';
import { BaAwaRules } from './BaAwaRules';
export class BaAwaMoveGenerator extends MancalaMoveGenerator {
    constructor() {
        super(BaAwaRules.get());
    }
}
